<mat-card class="menupannel">
  <div class="resUser">
    <button mat-flat-button (click)="chatUser()"> <mat-icon>chat_bubble_outline</mat-icon> Chat</button>
  </div>
  <div class="d">
    <button mat-flat-button (click)="chatFiles()"> <mat-icon>keyboard_arrow_left</mat-icon> Files </button>
  </div>
</mat-card>

<div class="chatWrapper">
  <div class="chatUser" [ngClass]="{'open': showChatUser }"><app-chat-users></app-chat-users></div>
  <div class="chatUserOverlay" (click)="chatUser()" [ngClass]="{'open': showChatUser }"></div>
  <div class="chatHolder"><router-outlet></router-outlet></div> 
  <div class="chatFiles" [ngClass]="{'open': showChatFiles }"><app-chat-files></app-chat-files></div>
  <div class="chatFilesOverlay"  (click)="chatFiles()" [ngClass]="{'open': showChatFiles }"></div>
</div>

